import { useEffect, useState } from 'react';
import SnackBar from 'components/SnackBar';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import usePostData from '../../../hooks/usePostData';
import useFetchData from '../../../hooks/useFetchData';
// import fields from '../fields';
import fields from './fields';
import { useParams } from 'react-router-dom';

import '../styles.scss';

const EditSurveyText = () => {
  const { idd } = useParams();
  const [currentReportField, setCurrentReportField] = useState(null);
  const { postData, res, payload, error } = usePostData();
  const [showSnackbar, setShowSnakbar] = useState(false);
  const fieldOptions = fields();
  console.log(fieldOptions);

  let { data } = useFetchData('survey-text', idd);
  console.log(data);

  useEffect(() => {
    setCurrentReportField(data);
  }, [data]);

  useEffect(() => {
    if (res && res.affected === 1) {
      setShowSnakbar(true);
    }
  }, [res, payload, error]);

  const onSubmit = (data) => {
    postData(`survey-text/${idd}`, data, 'patch');
  };

  return (
    <div className="edit-text">
      {currentReportField && (
        <div>
          <SectionHeader></SectionHeader>
          <FormGroup
            fields={fieldOptions}
            data={currentReportField}
            onSubmit={onSubmit}
          ></FormGroup>
          {showSnackbar && (
            <SnackBar
              msg={'שדה עודכן'}
              handleClose={() => setShowSnakbar(false)}
            ></SnackBar>
          )}
        </div>
      )}
    </div>
  );
};

export default EditSurveyText;
